export var IntelligentPhotoCaptureVinOption;
(function (IntelligentPhotoCaptureVinOption) {
    IntelligentPhotoCaptureVinOption["VIN"] = "VIN";
    IntelligentPhotoCaptureVinOption["VIN_STICKER"] = "VIN_STICKER";
})(IntelligentPhotoCaptureVinOption || (IntelligentPhotoCaptureVinOption = {}));
//# sourceMappingURL=IntelligentPhotoCaptureVinOption.js.map